<template>
	<div class="loadings.main">
		<el-form
			ref="editorForm"
			:model="info"
			status-icon
			label-position="top"
			size="mini"
			v-loading="loadings.main"
			v-if="hasGetTableDataModel"
			@submit.native.prevent
			:rules="rules"
		>
			<div class="row">
				<div
					:class="key.col ? 'col-md-' + key.col : 'col-md-12'"
					v-for="(key, index) in fields"
					:key="index"
				>
					<el-form-item :label="tableDataModel[key.name].show_name" :prop="key.name">
						<field-editor
							:width="key.width"
							v-model="info[key.name]"
							@change.native="handleFormEdited"
							@change="handleFormEdited"
							:field-info="tableDataModel[key.name]"
							:params="key.params"
						></field-editor>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<div class="footer" v-loading="loadings.formLoading">
			<el-button size="mini" @click="goActiveInfo()">查 看</el-button>
			<el-button size="mini" type="primary" @click="doConfirmEdit()">确 定</el-button>
		</div>
	</div>
</template>

<script>
import FieldEditor from "@/components/FieldEditor.vue";

export default {
	data() {
		return {
			loadings: {
				formLoading: false,
				main: false,
			},
			info: {},
			styles: [],
			everEdited: false,
			rules: {},
			fields: [
				{
					name: "brand",
					rules: ["required"],
					width: "100%",
					col: 3,
				},
				{
					name: "name",
					rules: ["required"],
					width: "100%",
					col: 3,
				},
				{
					name: "is_free",
					rules: ["required"],
					width: "100%",
					col: 3,
				},
				{
					name: "price",
					rules: ["required"],
					width: "100%",
					col: 3,
				},

				{
					name: "type",
					width: "100%",
					col: 3,
				},
				// {
				// 	name: "amount",
				// 	col: 3,
				// },
				{
					name: "stores",
					col: 12,
				},

				{
					name: "publish_at",
					col: 2,
					params: {
						type: "ts",
					},
				},

				{
					name: "begin_at",
					col: 2,
					params: {
						type: "ts",
					},
				},
				{
					name: "end_at",
					col: 2,
					params: {
						type: "ts",
					},
				},
				{
					name: "open_at",
					col: 2,
					params: {
						type: "ts",
					},
				},
				{
					name: "sale_at",
					col: 4,
					params: {
						type: "ts",
					},
				},

				{
					name: "colores",
					rules: ["required"],
					width: "100%",
					col: 6,
				},
				{
					name: "models",
					rules: ["required"],
					width: "100%",
					col: 6,
				},
				{
					name: "like_count",
					rules: ["required"],
					col: 4,
				},
				{
					name: "is_white",
					rules: ["required"],
					col: 4,
				},
				{
					name: "is_published",
					rules: ["required"],
					col: 4,
				},
			],
		};
	},
	props: {
		dataModel: {
			type: String,
			default: "",
		},
		hasGetTableDataModel: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
		tableDataModel: {
			type: Object,
			default: () => {
				return {};
			},
		},
		recordId: {
			type: String,
			default: "",
		},
		show: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: "name",
		},
	},
	mounted() {},
	computed: {},
	methods: {
		handleFormEdited() {
			this.everEdited = true;
		},
		handleSelect() {},
		_refreshRules() {
			for (let i = 0; i < this.fields.length; i++) {
				if (!this.fields[i].rules) {
					continue;
				}
				let real_rule = [];
				if (this.rules[this.fields[i].name]) {
					real_rule = this.rules[this.fields[i].name];
				}
				for (let j = 0; j < this.fields[i].rules.length; j++) {
					let rule = this.fields[i].rules[j];
					if (rule == "required") {
						if (
							this.tableDataModel[this.fields[i].name].type ==
							"Field_relate_simple_id"
						) {
							real_rule.push({
								required: true,
								message: "请输入",
								trigger: "change",
								type: "object",
								fields: {
									_id: { type: "string", required: true, message: "请选择" },
								},
							});
						} else {
							real_rule.push({
								required: true,
								message: "请输入",
								trigger: "change",
							});
						}
					} else if (rule !== null && typeof rule === "object") {
						real_rule.push(rule);
					}
				}
				if (real_rule.length > 0) {
					this.$set(this.rules, this.fields[i].name, real_rule);
				}
			}
		},
		goActiveInfo(id) {
			this.$router.push({
				name: "Active-Info",
				params: {
					id: this.recordId,
				},
			});
		},
		doConfirmEdit() {
			if (!this.everEdited) {
				this.$message.warning("数据无变化");
				return;
			}
			this.$refs["editorForm"].validate(valid => {
				if (!valid) {
					return false;
				}
				this.loadings.formLoading = true;
				const post = {};
				this.fields.forEach(field => {
					post[field.name] = this.info[field.name];
				});

				this.$axios
					.post(`/curd/do_edit/${this.dataModel}/${this.recordId}`, post)
					.then(json => {
						this.loadings.formLoading = false;
						for (let k in json.data.info) {
							this.$set(this.info, k, json.data.info[k]);
						}
						this.$message.success("成功");
						this.$emit("change", JSON.parse(JSON.stringify(this.info)));
					})
					.catch(json => {
						this.loadings.formLoading = false;
						this.$message.error(json.data.msg);
					});
			});
		},
	},
	components: {
		FieldEditor,
	},
	watch: {
		hasGetTableDataModel() {
			this._refreshRules();
		},
		value: {
			handler(val) {
				for (let i = 0; i < this.fields.length; i++) {
					let k = this.fields[i].name;
					this.$set(this.info, k, this.value[k]);
				}
			},
			immediate: true,
		},
	},
};
</script>
